import script from "./WineDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./WineDetails.vue?vue&type=script&setup=true&lang=js"

import "./WineDetails.vue?vue&type=style&index=0&id=3e9540a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e9540a0"]])

export default __exports__